import { render, staticRenderFns } from "./formgroupdoubleswitch.vue?vue&type=template&id=b9ebdc20&"
import script from "./formgroupdoubleswitch.vue?vue&type=script&lang=js&"
export * from "./formgroupdoubleswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports